'use strict';

function BcaFilterModel(ModelFactory,
                        $rootScope) {

  var filterModel = ModelFactory.create('BcaFilterModel', [
    'filter',
    'unfilteredBcas',
    'bcas'
  ]);

  filterModel.filter('');
  filterModel.bcas([]);
  filterModel.unfilteredBcas([]);

  filterModel.onFilterChanged($rootScope, onBcasOrFilterChanged);
  filterModel.onUnfilteredBcasChanged($rootScope, onBcasOrFilterChanged);

  function onBcasOrFilterChanged() {
    filterModel.bcas(applyFilter(filterModel.unfilteredBcas()));
  }

  var FILTERS = [
    function (bcaAccount) {
      return _.get(bcaAccount, 'bcaNumber', '');
    },
    function (bcaAccount) {
      return _.get(bcaAccount, 'siteName', '');
    },
    function (bcaAccount) {
      return _.get(bcaAccount, 'bcaName', '');
    },
    function (bcaAccount) {
      return _.get(bcaAccount, 'description', '');
    }
  ];

  function applyFilter(bcas) {
    var filter = filterModel.filter();
    if (_.isEmpty(filter)) {
      return bcas;
    }

    return _.filter(bcas, function (bca) {
      return _.some(FILTERS, function (filter) {
        var filtered = _.toUpper(filter(bca));
        return filtered.indexOf(_.toUpper(filterModel.filter())) > -1;
      });
    });
  }

  return filterModel;
}

angular.module('amexReconciliationApp')
  .service('BcaFilterModel', BcaFilterModel);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/BcaFilterModel.js
// module id = 573
// module chunks = 0